<template>
    <!-- Composant qui gère les boutos d'incrémentation/décrémentation du module -->
     
    <button class="tenjityModule-item-btn2" title="Ouvrir ou Fermer" @click.stop="handleClick($event)" :disabled="isDisabled">
        <template v-if="type === 'minus'">
            <Icon icon="fluent:subtract-12-filled" />
        </template>
        <template v-if="type === 'more'">
            <Icon icon="fluent:add-24-filled" />
        </template>
    </button>
</template>

<script>
import { Icon } from "@iconify/vue";

export default {
    name: "AccessibilityBtn",
    components: {
        Icon,
    },
    props: {
        type: String,
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        handleClick(event) {
            if (this.isDisabled) return;
            this.$emit("handleClick", event);
        },
    },
};
</script>
